import { Routes } from "@angular/router";
import { NotFoundComponent } from "@husbanken/designsystem-angular-core";
import { IsAuthenticated } from "@husbanken/frontend-starter";
import { Start } from "./pages/start/start";
import { Oppsummering } from "./pages/oppsummering/oppsummering";
import { Kartlegging } from "./pages/kartlegging/kartlegging";
import { kartleggingResolver } from "./services/kartlegging/KartleggingResolver";
import { TiltakBeskrivelse } from "./pages/tiltak-beskrivelse/tiltak-beskrivelse";
import { oppsummeringResolver } from "./services/oppsummering/oppsummeringResolver";
import { tiltakResolver } from "./services/tiltak/tiltakResolver";
import { DelBoligkompass } from "./pages/del-boligkompass/del-boligkompass";
import { KartleggingAvslutt } from "./pages/kartlegging-avslutt/kartlegging-avslutt";
import { KartleggingService } from "./services/kartlegging/KartleggingService";

export const appRoutes: Routes = [
  {
    path: "",
    component: Start,
    canActivate: [IsAuthenticated],
  },
  {
    path: "oppsummering/:id",
    component: Oppsummering,
    canActivate: [IsAuthenticated],
    resolve: {
      oppsummering: oppsummeringResolver,
    },
  },
  {
    path: "kartlegging",
    component: Kartlegging,
    canActivate: [IsAuthenticated],
    providers: [KartleggingService],
    resolve: { init: kartleggingResolver },
    data: { hideHeader: true },
  },
  {
    path: "tiltak-beskrivelse/:id",
    component: TiltakBeskrivelse,
    canActivate: [IsAuthenticated],
    resolve: {
      tiltak: tiltakResolver,
    },
  },
  {
    path: "del-boligkompass/:id",
    component: DelBoligkompass,
    canActivate: [IsAuthenticated],
  },
  {
    path: "kartlegging/avslutt",
    component: KartleggingAvslutt,
    canActivate: [IsAuthenticated],
  },
  {
    path: "**",
    component: NotFoundComponent,
  },
];
